import { UploadShareholdersExcelResponse } from "@/api/ApiService.ts";
import { TMessage } from "@/i18n/tt";

export type ShareholderExcelResultOutcome = "changed" | "nothing-changed";

export type ShareholderExcelResultCount = {
  key: string;
  label: TMessage;
  value: number;
};

export const shareholderExcelResultOutcome = (
  result: UploadShareholdersExcelResponse,
): ShareholderExcelResultOutcome =>
  result.shareholderIds.length > 0 ? "changed" : "nothing-changed";

export const shareholderExcelResultCounts = (
  result: UploadShareholdersExcelResponse,
): ShareholderExcelResultCount[] => [
  {
    key: "updated",
    label: { key: "shareholders.excel-result.updated" },
    value: result.shareholderIds.length,
  },
  {
    key: "unchanged",
    label: { key: "shareholders.excel-result.unchanged" },
    value: result.unchangedCount,
  },
  {
    key: "skipped",
    label: { key: "shareholders.excel-result.skipped" },
    value: result.unmatchedRowCount,
  },
];
